// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NostrLoginController from "./nostr_login_controller"
application.register("nostr-login", NostrLoginController)

import SourceFormController from "./source_form_controller"
application.register("source-form", SourceFormController)

import BulkSelectController from "./bulk_select_controller"
application.register("bulk-select", BulkSelectController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import MarkdownEditorController from "./markdown_editor_controller"
application.register("markdown-editor", MarkdownEditorController)

import ActivityDetailController from "./activity_detail_controller"
application.register("activity-detail", ActivityDetailController)

import EventExpanderController from "./event_expander_controller"
application.register("event-expander", EventExpanderController)

import ContentBuilderController from "./content_builder_controller"
application.register("content-builder", ContentBuilderController)

import ContentEditorController from "./content_editor_controller"
application.register("content-editor", ContentEditorController)

import JobProgressController from "./job_progress_controller"
application.register("job-progress", JobProgressController)

import TemplateSelectorController from "./template_selector_controller"
application.register("template-selector", TemplateSelectorController)

import RagChatController from "./rag_chat_controller"
application.register("rag-chat", RagChatController)

import ChannelAiChatController from "./channel_ai_chat_controller"
application.register("channel-ai-chat", ChannelAiChatController)
